import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../../Layout/Topo';
import Overlay from '../../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class StaffPapersControleManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      fired: 1,
      alerts: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);
    this.exportPdf = this.exportPdf.bind(this);
    this.exportXls = this.exportXls.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.AlertColumn = this.AlertColumn.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/consulta/gestor/dados', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            staffs_select: responseJson.data,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      staffs: this.state.staffs,
      fired: this.state.fired,
      alerts: this.state.alerts,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/consulta/gestor/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.handleAlert('', '', 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  exportPdf(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      staffs: this.state.staffs,
      fired: this.state.fired,
      alerts: this.state.alerts,
    };

    self.handleAlert(this.locale.Papeletas.ConsultaDePapeletasGestores.aguardeEnquantoOArquivoEGerado, 'warning', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/consulta/gestor/pdf', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }


  exportXls(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      staffs: this.state.staffs,
      fired: this.state.fired,
      alerts: this.state.alerts,
    };

    self.handleAlert(this.locale.Papeletas.ConsultaDePapeletasGestores.aguardeEnquantoOArquivoEGerado, 'warning', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/consulta/gestor/xls', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  ActionsButtons (cell, row) {
    var url = '/papeleta/editar/' + cell;

    var botao = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
      </div>
    );

    return botao;
  }


  AlertColumn (cell, row) {

    if (cell === 'Sim') {
      var botao = (
        <span className="label label-danger" style={{ fontSize: 14 }}>
          {this.locale.general.sim}
        </span>
      );
    } else {
      var botao = (
        <span className="label label-success" style={{ fontSize: 14 }}>
          {this.locale.general.nao}
        </span>
      );
    }

    return botao;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Papeletas.ConsultaDePapeletasGestores.titulo}</h3>
      <hr/>

      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Papeletas.ConsultaDePapeletasGestores.formulario.DataInicial}:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder={this.locale.general.mesAno} required />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Papeletas.ConsultaDePapeletasGestores.formulario.DataFinal}:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder={this.locale.general.mesAno} required />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.Papeletas.ConsultaDePapeletasGestores.formulario.Tripulante}:</label>
            <Select
              className=""
              name="staffs"
              value={this.state.staffs}
              searchable={true}
              placeholder={''}
              multi={true}
              onChange={this.handleSelectChangeMultiple.bind(this, 'staffs')}
              options={this.state.staffs_select}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Papeletas.ConsultaDePapeletasGestores.formulario.ExibirDesligados}:</label>
            <Select
              className=""
              name="fired"
              value={this.state.fired}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'fired')}
              options={[
                {label: this.locale.general.sim, value: 1},
                {label: this.locale.general.nao, value: 0}
              ]}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Papeletas.ConsultaDePapeletasGestores.formulario.SomenteComAlertas}:</label>
            <Select
              className=""
              name="alerts"
              value={this.state.alerts}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'alerts')}
              options={[
                {label: this.locale.general.sim, value: 1},
                {label: this.locale.general.nao, value: 0}
              ]}
            />
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar}</button>
      </form>
      <hr/>
      <div className="row">
        <div className="col-md-6 form-group">
          <button onClick={() => {this.exportPdf()}} className="btn btn-success btn-block btn-lg"><i className="fa fa-fw fa-file-pdf-o"></i> {this.locale.general.exportarPDF}</button>
        </div>
        <div className="col-md-6 form-group">
          <button onClick={() => {this.exportXls()}} className="btn btn-warning btn-block btn-lg"><i className="fa fa-fw fa-file-excel-o"></i> {this.locale.general.exportarXLS}</button>
        </div>
      </div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' '}} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
        <TableHeaderColumn dataField="staff_name" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}}>{this.locale.Papeletas.ConsultaDePapeletasGestores.tabela.Tripulante}</TableHeaderColumn>
        <TableHeaderColumn dataField="month" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}}>{this.locale.Papeletas.ConsultaDePapeletasGestores.tabela.MesAno}</TableHeaderColumn>
        <TableHeaderColumn dataField="alerts" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} dataFormat={this.AlertColumn}>{this.locale.Papeletas.ConsultaDePapeletasGestores.tabela.Alertas}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Papeletas.ConsultaDePapeletasGestores.tabela.Acoes}</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffPapersControleManager;



// WEBPACK FOOTER //
// ./src/Components/StaffPapers/Control/StaffPapersControleManager.js